import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import Slider from "react-slick"
import styled from "styled-components";
import { Link } from "react-router-dom";

import { connect } from "react-redux"

import ArrowPrev from "../../../images/arrow/luxury_prev.png";
import ArrowNext from "../../../images/arrow/luxury_next.png";

// Redux
import { getPopularBrands } from "../../../actions/kafairAction"
import { getCloudImageUrl } from "../../../utils/Helpers"

const PreviousArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 10px;
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
    }

    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, left: "40px !important", width: "40px", height: "40px", left: "-50px !important" }}
      onClick={onClick}
    >
      <KickImage src={ArrowPrev} alt="..." />
    </LeftArrow>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      right: -5px;
      position: absolute;
    }

    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowNext} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  swipe: true,
  prevArrow: <PreviousArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function LuxuryBrand({ getPopularBrands, brandData, history }) {

  const [hoverId, setHoverId] = useState(0)

  useEffect(() => {
    getPopularBrands({ category: "handbags" })
  }, [])

  function handleOnClick(url) {
    history.push(`/search/luxury/${url.toLowerCase()}`)
  }

  function onHoverBrand(id) {
    setHoverId(id)
  }

  return (
    <div className="hot-products-section">
      <div className="luxury-brand-slides">
        <h6>Brands</h6>
        <p className="view-all">
          <Link to={"/luxury/brands"} target="_blank">
            View All
        </Link>
        </p>
        <Slider {...settings}>
          {
            brandData && brandData.map((item, index) => {
              const imageLandscape = item.images && item.images.length > 0 ? item.images.filter(img => img.orientation === "landscape") : [];

              return (
                <div onMouseEnter={() => onHoverBrand(item.id)} onMouseLeave={() => onHoverBrand(0)} onClick={() => handleOnClick(item.name)} style={{ background: `url(${imageLandscape.length > 0 ? getCloudImageUrl(imageLandscape[0].URL, 600) : ""})`, backgroundSize: "cover", backgroundPosition: "center" }} className="luxury-brand-slide">
                  {
                    hoverId === item.id && <KickImage className="luxury-slide-onhover" src={imageLandscape.length >= 1 ? getCloudImageUrl(imageLandscape[1].URL, 600) : ""} alt="hover" />
                  }
                  <KickImage className="luxury-slide-logo" src={item.img_url ? getCloudImageUrl(item.img_url, 300) : ""} alt="logo" />
                </div>
              )
            })
          }
        </Slider>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  brandData: state.dataKaFair.categoryBrand.popularBrands
})

const mapDispatchToProps = dispatch => ({
  getPopularBrands: (query) => dispatch(getPopularBrands(query))
})

export default connect(mapStateToProps, mapDispatchToProps)(LuxuryBrand)